import { IAppTrackerConfig } from "../../main";

export const setAppConfigOnWindowForTrackers = (appConfig: IAppTrackerConfig) => {
  const { getNRAccountId, getNRAgentId, getNRLicenseKey, getPendoApiKey, getAppId, getAppVersion } =
    appConfig;

  window.appTrackerConfig = {
    getNRAccountId,
    getNRAgentId,
    getNRLicenseKey,
    getPendoApiKey,
    ...(getAppId && getAppVersion && { getAppId, getAppVersion }),
  };
};
